export default __webpack_public_path__ + "static/media/tc.4b450ef0.png";